import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { localizePath } from "@/i18n/translations";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ lang, children }) => {
  const { isAuthenticated, sessionExpiredMessage, clearSessionExpiredMessage } = useAuth();
  const location = useLocation();

  // Show toast message when session expires
  useEffect(() => {
    if (sessionExpiredMessage) {
      toast.error(sessionExpiredMessage, {
        duration: 6000,
      });
      clearSessionExpiredMessage();
    }
  }, [sessionExpiredMessage, clearSessionExpiredMessage]);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={localizePath(lang, "/staff/login")}
        replace
        state={{ from: location.pathname, sessionExpired: Boolean(sessionExpiredMessage) }}
      />
    );
  }

  return children;
};
